import { CopyAll } from "@mui/icons-material";
import { Autocomplete, Grid, Switch, TextField } from "@mui/material";
import { AloveSwitch } from "components/alove/AloveSwitch";
import { T } from "components/alove/Translator";
import { addAlert, useMaterialUIController } from "context";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { Attribute, AttributePolicy } from "models/profile/Attribute";
import { ProfileAttributePolicy } from "models/profile/Profile";
import { useEffect, useState } from "react";
import { getGeneralCodes } from "utils/generalCodesUtils";
import { tr } from "utils/globalsUtils";

const MDInput = require("components/MDInput/index.js").default;
const MDTypography = require("components/MDTypography").default;

export const AttrDisplay = ({
  attribute,
  setAttribute,
}: {
  attribute: Attribute;
  setAttribute: any;
}) => {
  const [controller, dispatch] = useMaterialUIController();
  const [categories, setCategories] = useState([] as GeneralCode[]);

  useEffect(() => {
    getGeneralCodes(GeneralCodeType.AttributeCategory).then((res) => {
      setCategories(res);
    });
  }, []);

  return (
    <Grid container spacing={2} columnSpacing={5}>
      <Grid size={4}>
        <MDInput
          label="Code"
          fullWidth
          value={attribute.name}
          disabled
        />
      </Grid>
      <Grid size={1}>
        <CopyAll 
          onClick={() => {
            navigator.clipboard.writeText(attribute.name);
            addAlert(dispatch, "Key copied to clipboard");
          }}
        />
      </Grid>
      <Grid size={8} />
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <MDInput
          label="Display Name"
          value={attribute.txt}
          fullWidth
          onChange={(e: any) => setAttribute({ ...attribute, txt: e.target.value })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          xl: 6
        }}>
        <AloveSwitch
          title="Featured"
          subtitle="Featured field on public profile"
          value={attribute.isFeatured}
          setValue={(v) => setAttribute({ ...attribute, isFeatured: v })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <Autocomplete
          disableClearable
          options={["bio", "pref"]}
          value={attribute.attributeGroup}
          renderInput={(params) => <TextField {...params} label="Editable on screen" />}
          onChange={(e, o) => {
            setAttribute({ ...attribute, attributeGroup: o });
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          xl: 6
        }}>
        <AloveSwitch
          title="Sensitive attribute"
          subtitle="Sensitive data (Seperated from other data)"
          value={attribute.isSensitive}
          setValue={(v) => setAttribute({ ...attribute, isSensitive: v })}
          disabled
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <Autocomplete
          disableClearable
          fullWidth
          value={attribute.attributeCategory || ""}
          options={categories.map((c) => c.name)}
          getOptionLabel={(option) => tr(option)}
          renderInput={(params) => <TextField {...params} label="Category" />}
          onChange={(e, v) => setAttribute({ ...attribute, attributeCategory: v })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          xl: 6
        }}>
        <AloveSwitch
          title="Editable"
          subtitle="End users can edit field value after onboarding"
          value={attribute.userEditable}
          setValue={(v) => setAttribute({ ...attribute, userEditable: v })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <Autocomplete
          disableClearable
          value={attribute.defaultPolicy || AttributePolicy.Public}
          getOptionLabel={(option) => AttributePolicy[option]}
          options={Object.values(AttributePolicy).filter((a) => !isNaN(Number(a)))}
          renderInput={(params) => <TextField {...params} label="Visibility" />}
          onChange={(e, o) => setAttribute({ ...attribute, defaultPolicy: o })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          xl: 6
        }}>
        <AloveSwitch
          title="Privacy editable"
          subtitle="Users can change visibility"
          value={attribute.userToggleable}
          setValue={(v) => setAttribute({ ...attribute, userToggleable: v })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          xl: 9
        }}>
        {/* <MDInput
                          label="Extended Info"
                          size="small"
                          fullWidth
                          value={question.questionTexts["attribute.extended_info_txt_id"]}
                          onChange={(e) => {
                            question.questionTexts["attribute.extended_info_txt_id"] = e.target.value;
                            setQuestion({ ...question });
                          }}
                        /> */}
      </Grid>
    </Grid>
  );
};
